import { Typography } from '@mui/material'
import { Page } from 'components/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { isNil } from 'lodash'
import { LocationSweepstakesDetailsTabs } from './LocationSweepstakesDetailsTabs'
import { LocationSweepstakesStatusLabel } from '../LocationSweepstakesStatusLabel'
import { type Sweepstake } from 'src/types/api'

export const LocationSweepstakeDetailsHeader = ({
  sweepstake,
  currentTab,
  actionButton,
  children,
}: {
  sweepstake: Sweepstake
  currentTab: string
  actionButton?: React.ReactNode
  children?: React.ReactNode
}) => {
  if (!sweepstake.id) {
    return <Typography>Sweepstake Id must not be null.</Typography>
  }

  return (
    <Page
      header={
        <PageHeader
          title={isNil(sweepstake.name) ? 'Unknown' : sweepstake.name}
          backText="Location Sweepstakes"
          backPath="/LocationSweepstakes"
          isSecondary={true}
          status={
            <LocationSweepstakesStatusLabel
              status={sweepstake.sweepstakeData?.state ?? 'Draft'}
            />
          }
          actionButton={actionButton}
          tabs={
            <LocationSweepstakesDetailsTabs
              currentTab={currentTab}
              sweepstakeId={sweepstake.id}
            />
          }
        />
      }
    >
      {children}
    </Page>
  )
}
